import { atom } from 'jotai';

export const draftMessageAtom = atom<Record<number, string>>({});
